export const SOLAR_INTRO = {
  title: 'Введение',
  whatIsSolar: `Соляр (или солярное возвращение) — это один из самых точных и глубоких методов астрологического прогнозирования. Солярная карта строится на тот точный момент времени, когда транзитное Солнце возвращается в тот же самый градус, минуту и секунду, в которых оно находилось в момент вашего рождения. Это происходит каждый год вблизи вашего дня рождения.`,
  howItWorks: `В отличие от натальной карты, которая описывает ваш врождённый потенциал и характер на всю жизнь, солярная карта действует ровно один год — от одного дня рождения до следующего. Она показывает, какие именно сферы вашей натальной карты будут активированы в этом году, какие задачи выйдут на первый план, и с какими энергиями вам предстоит работать.`,
  whatItShows: `Соляр не отменяет натальную карту, он накладывается на неё. Если натальная карта — это сценарий всей вашей жизни, то соляр — это сценарий конкретного сезона вашего личного сериала. Прогноз показывает основные тенденции года, ключевые события, психологическую атмосферу и даёт рекомендации, как максимально эффективно использовать приходящие энергии.`,
}

export const SOLAR_YEAR_THEME = {
  title: 'Общая тема года',
  mainEnergy: 'Трансформация через коммуникацию и карьерный прорыв',
  description: `2026 год станет для вас периодом значительного ускорения и выхода на новые социальные орбиты. Энергия года требует от вас гибкости, готовности быстро усваивать новую информацию и умения договариваться. Это не время для затворничества — год потребует максимальной социальной активности и проявления себя в профессиональной сфере.`,
  tasks: [
    'Масштабирование профессионального влияния',
    'Создание новых полезных связей и нетворкинг',
    'Обучение новым практическим навыкам',
    'Пересмотр структуры доходов и расходов',
  ],
  changes:
    'Основные изменения коснутся вашего социального статуса и профессиональной реализации. Возможна смена должности, переход на новый уровень ответственности или запуск важного публичного проекта.',
  atmosphere:
    'Психологически год будет ощущаться как очень динамичный, местами суетливый, но невероятно продуктивный. Возможны периоды информационной перегрузки, поэтому важно научиться фильтровать контакты.',
  growthPoints:
    'Ваша главная точка роста в этом году — умение делегировать и выстраивать эффективные коммуникации. Успех придёт через слово, текст и умение убеждать.',
}

export const SOLAR_ASCENDANT = {
  sign: 'Близнецы',
  symbol: '♊',
  title: 'Асцендент соляра в Близнецах',
  description: `Асцендент соляра показывает, какую социальную маску вы будете носить в этом году, как будете реагировать на новые ситуации и как вас будут воспринимать окружающие. Восходящие Близнецы делают вас невероятно подвижным, контактным и открытым новому опыту.`,
  manifestation: `В этом году вы будете проявляться как человек лёгкий на подъём, любознательный и многозадачный. Ваша речь станет более быстрой, а ум — более цепким. Окружающие увидят в вас интересного собеседника и генератора идей.`,
  strategy: `Ваша главная стратегия на год — адаптивность. Не цепляйтесь за старые планы, если ситуация меняется. Будьте готовы перестраиваться на ходу. Чем больше вы общаетесь, задаёте вопросов и учитесь, тем успешнее будет год.`,
  perception: `Люди будут воспринимать вас как человека молодого душой, энергичного и компетентного в вопросах информации. К вам будут тянуться за советом, свежими идеями и просто ради интересной беседы.`,
}

export const SOLAR_SUN_POSITION = {
  house: 10,
  sign: 'Лев',
  title: 'Солнце в 10 доме соляра',
  description: `Солнце в соляре показывает ту сферу жизни, где будет сосредоточено ваше эго, где вы захотите сиять и получать признание. Положение Солнца в 10 доме — это классическое указание на год карьерных достижений и повышения социального статуса.`,
  keySphere: `Ключевая сфера года — карьера, репутация, отношения с властью и авторитетами, достижение долгосрочных целей.`,
  focus: `Всё ваше внимание будет направлено на то, чтобы занять более высокое положение в обществе или профессии. Вы захотите, чтобы ваши заслуги были признаны официально. Это год амбиций.`,
  events: [
    'Повышение в должности или получение важного проекта',
    'Официальное признание заслуг (награды, премии)',
    'Смена социального статуса',
    'Успешное взаимодействие с государственными структурами или руководством',
  ],
  strengths: [
    'Ярко выраженные лидерские качества',
    'Заметность для руководства',
    'Уверенность в своих профессиональных силах',
  ],
  cautions: [
    'Конфликты с начальством из-за гордыни',
    'Трудоголизм в ущерб семье',
    'Зависимость от внешнего одобрения',
  ],
}

export const SOLAR_MOON = {
  house: 6,
  sign: 'Скорпион',
  title: 'Луна в 6 доме соляра',
  description: `Луна в соляре описывает ваш эмоциональный фон, внутренние потребности и то, где вы будете искать зону комфорта (или где будете испытывать наибольшее беспокойство). Луна в 6 доме в Скорпионе указывает на интенсивную эмоциональную вовлечённость в рабочие процессы и вопросы здоровья.`,
  emotions: `Эмоциональный фон года может быть напряжённым из-за высокой ответственности на работе. Вы можете слишком глубоко переживать рабочие конфликты или несовершенство процессов. Возможна склонность к психосоматике при переутомлении.`,
  needs: `Ваша главная внутренняя потребность — навести порядок в рутине, трансформировать рабочие процессы, сделать их более эффективными. Вы нуждаетесь в том, чтобы чувствовать себя незаменимым специалистом.`,
  relations: `Отношения с коллегами и подчинёнными могут быть эмоционально окрашенными. Возможны тайные интриги на работе или глубокая привязанность к рабочему коллективу. Важно не переносить рабочие стрессы на домашних.`,
  strengths: [
    'Невероятная интуиция в рабочих вопросах',
    'Способность выдерживать высокие нагрузки',
    'Глубокое понимание скрытых процессов',
  ],
  cautions: [
    'Эмоциональное выгорание',
    'Психосоматические реакции на стресс',
    'Излишняя подозрительность к коллегам',
  ],
}

export const SOLAR_PLANETS_IN_HOUSES = [
  {
    planet: 'Меркурий',
    symbol: '☿',
    sign: 'Лев',
    house: 3,
    title: 'Меркурий в 3 доме',
    description:
      'Год интенсивного обучения, коротких поездок и активного нетворкинга. Ваш ум работает ярко и творчески. Отличное время для написания статей, ведения блога, публичных выступлений и оформления важных документов.',
    events: [
      'Покупка автомобиля',
      'Множество командировок',
      'Успешная сдача экзаменов',
      'Важные знакомства',
    ],
  },
  {
    planet: 'Венера',
    symbol: '♀',
    sign: 'Рак',
    house: 2,
    title: 'Венера во 2 доме',
    description:
      'Финансовая сфера тесно связана с эмоциями и семьёй. Доходы могут приходить через недвижимость, семейный бизнес или сферы, связанные с уютом и питанием. Траты часто эмоциональные — на обустройство дома или помощь близким.',
    events: [
      'Улучшение финансового положения',
      'Покупка красивых вещей для дома',
      'Доход от хобби',
    ],
  },
  {
    planet: 'Марс',
    symbol: '♂',
    sign: 'Близнецы',
    house: 1,
    title: 'Марс в 1 доме',
    description:
      'Огромный заряд личной энергии. Вы инициативны, смелы и готовы отстаивать свои интересы. Ваша активность направлена на самореализацию. Возможна склонность к спорам и поспешным действиям.',
    events: [
      'Начало занятий спортом',
      'Самостоятельный запуск проектов',
      'Конкурентная борьба',
    ],
  },
  {
    planet: 'Юпитер',
    symbol: '♃',
    sign: 'Дева',
    house: 4,
    title: 'Юпитер в 4 доме',
    description:
      'Расширение в сфере дома и семьи. Благоприятный год для решения жилищных вопросов, ремонта, переезда в более просторное жильё. Улучшение отношений с родителями, ощущение внутренней опоры.',
    events: [
      'Покупка недвижимости',
      'Прибавление в семье',
      'Удачный ремонт',
      'Помощь от родителей',
    ],
  },
  {
    planet: 'Сатурн',
    symbol: '♄',
    sign: 'Рыбы',
    house: 10,
    title: 'Сатурн в 10 доме',
    description:
      'Время взять на себя серьёзную ответственность в карьере. Сатурн требует дисциплины, упорства и профессионализма. Возможны проверки со стороны руководства, но при должном усердии — это закладка фундаментального успеха на годы вперёд.',
    events: [
      'Назначение на руководящую должность',
      'Официальная регистрация бизнеса',
      'Важные профессиональные испытания',
    ],
  },
  {
    planet: 'Уран',
    symbol: '♅',
    sign: 'Близнецы',
    house: 12,
    title: 'Уран в 12 доме',
    description:
      'Внезапные озарения, инсайты и освобождение от скрытых страхов. Возможен интерес к эзотерике, астрологии, психологии. Неожиданные события могут происходить в уединении или вдали от дома.',
    events: [
      'Резкая смена внутренних убеждений',
      'Неожиданные тайные покровители',
      'Внезапное желание уединения',
    ],
  },
  {
    planet: 'Нептун',
    symbol: '♆',
    sign: 'Овен',
    house: 11,
    title: 'Нептун в 11 доме',
    description:
      'Идеализация друзей и социальных групп. Вы можете примкнуть к благотворительным, творческим или духовным сообществам. Важно не стать жертвой обмана со стороны единомышленников.',
    events: [
      'Появление творческих друзей',
      'Участие в волонтёрских проектах',
      'Исполнение давней мечты',
    ],
  },
  {
    planet: 'Плутон',
    symbol: '♇',
    sign: 'Водолей',
    house: 9,
    title: 'Плутон в 9 доме',
    description:
      'Глубокая трансформация мировоззрения. Возможны интенсивные события, связанные с заграницей, высшим образованием или юридическими делами. Ваши убеждения пройдут проверку на прочность.',
    events: [
      'Кардинальная смена жизненной философии',
      'Важные юридические процессы',
      'Трансформирующая поездка за рубеж',
    ],
  },
]

export const SOLAR_ASPECTS = [
  {
    aspect: '☉ △ ASC',
    title: 'Солнце тригон Асцендент',
    nature: 'harmonious' as const,
    description:
      'Прекрасный аспект, дающий жизненную силу, уверенность в себе и способность легко реализовывать свои намерения. Ваше внутреннее "Я" находится в гармонии с тем, как вы проявляетесь во внешнем мире. Окружающие будут воспринимать вас позитивно, что поможет в достижении карьерных целей.',
  },
  {
    aspect: '☽ □ ♂',
    title: 'Луна квадрат Марс',
    nature: 'tense' as const,
    description:
      'Аспект эмоциональной импульсивности и раздражительности. Возможны конфликты на работе (так как Луна в 6 доме) из-за поспешных действий или резких слов (Марс в 1 доме). Важно учиться контролировать гнев и не принимать решения на эмоциях. Энергию аспекта лучше направлять в активную работу или спорт.',
  },
  {
    aspect: '♃ ☍ ♄',
    title: 'Юпитер оппозиция Сатурн',
    nature: 'tense' as const,
    description:
      'Внутренний конфликт между желанием расширения (Юпитер в 4 доме - дом, семья) и профессиональным долгом (Сатурн в 10 доме - карьера). Вам придётся балансировать между необходимостью много работать и желанием проводить время с семьёй или заниматься домом. Возможны препятствия при попытках быстрого роста.',
  },
  {
    aspect: '☿ ⚹ ♅',
    title: 'Меркурий секстиль Уран',
    nature: 'harmonious' as const,
    description:
      'Аспект гениальных идей и нестандартного мышления. Отличное время для изучения новых технологий, астрологии, программирования. Вы способны находить оригинальные решения старых проблем. Благоприятно для нетворкинга и запуска инновационных проектов.',
  },
]

export const SOLAR_LIFE_AREAS = [
  {
    id: 'career',
    title: 'Карьера и деньги',
    icon: 'briefcase',
    color: 'emerald',
    analysis:
      'Это ключевая сфера года. С Солнцем в 10 доме и Сатурном там же, от вас потребуется максимум профессионализма. Это не год для расслабления. Возможен серьёзный карьерный рост, но он будет результатом упорного труда, а не слепой удачи. Финансовая ситуация стабильна, доходы могут расти благодаря недвижимости или семейной поддержке (Венера во 2 доме в Раке). Избегайте импульсивных трат на эмоциях.',
  },
  {
    id: 'relationships',
    title: 'Отношения и любовь',
    icon: 'heart',
    color: 'rose',
    analysis:
      'Сфера отношений в этом году отходит на второй план по сравнению с карьерой. Однако Венера в Раке делает вас более чувствительным и ориентированным на создание уюта. Если вы в паре, важно не переносить рабочие стрессы в дом. Для одиноких возможны знакомства через работу или в поездках (Меркурий в 3 доме). Главный вызов — найти баланс между амбициями и временем для близких.',
  },
  {
    id: 'family',
    title: 'Семья и дом',
    icon: 'home',
    color: 'amber',
    analysis:
      'Юпитер в 4 доме делает эту сферу зоной расширения и удачи. Отличный год для покупки недвижимости, ремонта, переезда или расширения семьи. Отношения с родителями могут улучшиться, вы можете получить от них существенную поддержку. Дом станет для вас местом силы и восстановления энергии после напряжённых рабочих будней.',
  },
  {
    id: 'growth',
    title: 'Личностное развитие',
    icon: 'trending-up',
    color: 'indigo',
    analysis:
      'Асцендент в Близнецах и Меркурий в 3 доме указывают на колоссальный интеллектуальный рост. Вы будете впитывать информацию как губка. Главная задача — не распыляться на множество поверхностных курсов, а выбрать 1-2 направления, которые реально помогут вашей карьере. Плутон в 9 доме потребует пересмотра ваших глобальных убеждений и философии.',
  },
  {
    id: 'health',
    title: 'Здоровье и энергия',
    icon: 'activity',
    color: 'teal',
    analysis:
      'Марс в 1 доме даёт много физической энергии, но Луна в 6 доме в Скорпионе предупреждает о риске психосоматики на фоне рабочих стрессов. Ваша нервная система может быть перегружена. Крайне важно соблюдать режим труда и отдыха. Рекомендуются регулярные физические нагрузки для сброса напряжения (бег, плавание) и практики релаксации.',
  },
  {
    id: 'social',
    title: 'Социальная жизнь',
    icon: 'users',
    color: 'sky',
    analysis:
      'Нептун в 11 доме может принести в вашу жизнь необычных, творческих или духовно ориентированных друзей. Однако есть риск разочарования в ком-то из старого окружения. Ваш круг общения значительно расширится благодаря активному нетворкингу (3 дом). Выбирайте окружение осознанно — в этом году связи решают многое.',
  },
]

export const SOLAR_RECOMMENDATIONS = [
  {
    title: 'Фокус на карьере',
    text: 'Используйте энергию 10 дома по максимуму. Берите на себя ответственность, заявляйте о своих амбициях руководству, запускайте важные проекты. Это год, когда закладывается фундамент вашего статуса на следующие несколько лет.',
  },
  {
    title: 'Управление информацией',
    text: 'С Асцендентом в Близнецах вы будете получать море информации. Учитесь фильтровать её. Записывайте идеи, ведите ежедневник, структурируйте знания. Не вступайте в пустые споры (Марс в 1 доме).',
  },
  {
    title: 'Баланс "Работа-Дом"',
    text: 'Оппозиция Юпитера и Сатурна потребует от вас виртуозного тайм-менеджмента. Не жертвуйте семьёй ради карьеры, но и не прячьтесь дома от профессиональных вызовов. Дом должен стать вашим ресурсом.',
  },
  {
    title: 'Эмоциональная гигиена',
    text: 'Луна в 6 доме в Скорпионе требует внимания к психосоматике. Найдите экологичные способы сброса рабочего напряжения. Не копите обиды на коллег, решайте конфликты конструктивно.',
  },
]

export const SOLAR_SUMMARY = {
  overview: `2026 год — это год вашего социального и профессионального взросления. Энергии соляра требуют от вас выйти из тени, взять на себя ответственность и заявить о своих амбициях. Сочетание карьерного фокуса (Солнце и Сатурн в 10 доме) с информационной подвижностью (Асцендент в Близнецах) даёт вам все инструменты для достижения успеха.`,
  opportunities: `Главные возможности года лежат в сфере карьеры, недвижимости и обучения. Вы можете существенно повысить свой статус, улучшить жилищные условия и обрасти полезными связями.`,
  lessons: `Ключевой урок года — научиться балансировать между высокими амбициями и потребностями семьи, а также управлять своей энергией, не допуская выгорания и психосоматических срывов. Действуйте смело, но стратегически выверенно.`,
}
